import { DataGridPremium, GridColDef, useGridApiRef } from '@mui/x-data-grid-premium';
import {  useCallback, useMemo } from 'react';

export interface IPremMealInventorySummary {
    item : any;
}

function PremMealInventorySummary(props : IPremMealInventorySummary) {
    const apiRef = useGridApiRef();

    const findClosingInventory = useCallback((name : string) => {
        let list = props.item.inventory_records as any[];
        return list.find(o => o.item === name);
    }, [props.item]);

    const nameOfItem = (name : string) => {
        if(name.indexOf(':') >= 0)
            return name.split(':')[1];

        return name;
    }

    const nameOfService = (name : string) => {
        if(name.indexOf(':') >= 0)
            return name.split(':')[0];

        return 'Snack';
    }
  
    const rows = useMemo(() => {
        const result = props?.item?.opening_stock?.map((o : any) => { return {
            ...o,
            id: o.name,
            name: nameOfItem(o.name),
            service: nameOfService(o.name),
            openingCount: o.count,
            closingCount: findClosingInventory(o.name)?.count
        }}) ?? [];
        return result.sort((a: any,b : any) => a.id < b.id ? -1 : 1);
    }, [props.item, findClosingInventory]);

    const columns: GridColDef[] = [ 
        { field: 'name', headerName: 'Item', minWidth: 120 },
        { field: 'service', headerName: 'Service', minWidth: 120 },
        { field: 'openingCount', headerName: 'Opening', minWidth: 100 },
        { field: 'closingCount', headerName: 'Closing', minWidth: 100 },
    ];

    return (
    <>
        <DataGridPremium
            apiRef={apiRef}
            autoHeight
            rows={rows}
            columns={columns}
            editMode='row'
            isCellEditable={(o) => false}
            rowSelection={true}
            getRowClassName={(params) => { return params.indexRelativeToCurrentPage % 2 === 1 ? `tui-grid-alternate-row` : ''}}
            
        />
    </>
        
    );
}

export default PremMealInventorySummary;